export default __webpack_public_path__ + "static/media/header-image.375cc902.png";